import { render } from "./JarvisEmbed.vue?vue&type=template&id=754f50a0&scoped=true"
import script from "./JarvisEmbed.vue?vue&type=script&lang=js"
export * from "./JarvisEmbed.vue?vue&type=script&lang=js"

import "./JarvisEmbed.vue?vue&type=style&index=0&id=754f50a0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754f50a0"]])

export default __exports__